import { render, staticRenderFns } from "./msg-item.vue?vue&type=template&id=030aa16c&"
import script from "./msg-item.vue?vue&type=script&lang=js&"
export * from "./msg-item.vue?vue&type=script&lang=js&"
import style0 from "./msg-item.vue?vue&type=style&index=0&id=030aa16c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports